// Mint-TMS-Trip · dữ liệu mẫu của trang chi tiết lệnh vận tải TRF2610078 (đúng dòng + thứ tự của board). Không có tiền.
// Nguồn thật về sau: TblTRFOrder + TblTRFLeg + TblTRFPhoto… qua DataSource. Mốc giờ nguyên văn board (giờ làm việc không tính ở đây).

export type Tone = 'ok' | 'warn' | 'err' | 'info' | 'mute';
export type LegSource = 'Tài xế' | 'GPS tự ghi' | 'GPS đề xuất';
export type ActCat = 'driver' | 'dispatch' | 'system' | 'gps' | 'chat';

export interface Stop {
  key: 'pick' | 'load' | 'drop';
  label: string;
  place: string;
  /** giờ đã có / dự kiến */
  time: string;
  /** thực tế | dự kiến */
  kind: 'thực tế' | 'dự kiến';
  /** dòng phụ dưới giờ ("trước là 05:30 · trễ 28′") — chỉ khi lệch */
  shift?: string;
  late?: boolean;
  /** mã nhận / hạ */
  code?: string;
  /** giờ mở kho */
  hours?: string;
  note: string;
  /** màu nền ô điểm: done (xanh lá) | next (xanh dương) */
  tone: 'done' | 'next';
  /** màu đường nối tới điểm sau */
  line?: 'done' | 'next';
}

export interface Metric {
  label: string;
  value: string;
  unit: string;
  /** % thanh tiến độ (0..100) */
  pct: number;
  tone: 'blue' | 'amber' | 'green';
  /** vạch chuẩn (% trên thanh) */
  mark?: number;
  /** tô giá trị */
  hot?: 'warn' | 'ok';
}

export interface Leg {
  n: string;
  kind: string;
  route: string;
  time: string;
  km: string;
  source: LegSource;
  /** chặng GPS đề xuất chờ tài xế / điều độ xác nhận */
  pending?: boolean;
}

export interface PhasePhoto {
  key: string;
  label: string;
  n: number;
}

export interface TripNote {
  text: string;
  kind: string;
  by: string;
  at: string;
  pinned?: boolean;
}

export interface Activity {
  tag: string;
  text: string;
  who: string;
  /** tên viết tắt hiển thị trong avatar; không có = icon người */
  ini?: string;
  at: string;
  cat: ActCat;
  tone: 'teal' | 'mute';
}

export interface Todo {
  text: string;
  who: string;
  ini: string;
  due: string;
  dueTone: Tone;
  action: string;
}

export interface Pic {
  who: string;
  ini: string;
  role: string;
  /** vai chưa giao */
  none?: boolean;
  tone: 'violet' | 'blue' | 'mute';
}

export interface TripDetail {
  id: string;
  status: string;
  /** chip "thiếu N mục Finish" */
  missing: number;
  sub: string;
  planCount: string;
  last: string;
  next: string;
  runtime: string;
  runtimeSub: string;
  stops: Stop[];
  chips: Array<{ icon: 'truck' | 'mooc' | 'cont' | 'km' | 'driver'; text: string }>;
  cutoff: { tone: Tone; tag: string; ok: string; text: string };
  score: { value: number; weekAgo: number };
  metrics: Metric[];
  flags: string[];
  legs: Leg[];
  legsPendingMsg: string;
  photos: PhasePhoto[];
  notes: TripNote[];
  docs: { have: number; total: number };
  activity: Activity[];
  activityTotal: number;
  activityCounts: Record<'all' | ActCat, number>;
  todos: Todo[];
  todosTotal: number;
  info: Array<{ k: string; v: string; link?: boolean; copy?: boolean; edit?: boolean }>;
  restrictions: Array<{ text: string; tone: Tone }>;
  pics: Pic[];
  driver: { ini: string; name: string; status: string };
}

export const TRIP_DETAIL: Record<string, TripDetail> = {
  TRF2610078: {
    id: 'TRF2610078',
    status: 'Processing',
    missing: 3,
    sub: 'SE260637420 · SAVITA · ICD PHUOC LONG 3 → Cat Lai Giang Nam · 40HC TGHU8123457 · ngày 23/10/2026 06:00',
    planCount: '2/3 điểm',
    last: '12:40 · Rời kho SAVITA · ảnh LeaveWarehouse ×2 · HANA Mov',
    next: 'Hạ cảng Cát Lái Giang Nam · dự kiến 14:05 (GPS)',
    runtime: '3 g 40′',
    runtimeSub: 'GPS TB theo tuyến',
    stops: [
      { key: 'pick', label: 'Lấy rỗng', place: 'ICD PHUOC LONG 3', time: '05:58', kind: 'thực tế', shift: 'trước là 05:30 · trễ 28′', late: true, code: 'PickupCode YML-ER-261023-114', note: 'Đến cổng 2, đưa lệnh cấp rỗng', tone: 'done', line: 'done' },
      { key: 'load', label: 'Kho đóng hàng', place: 'Kho khách SAVITA · Bình Dương', time: '08:12', kind: 'thực tế', hours: 'Kho mở 07:00–16:00', note: 'Chèn lót sàn, chụp ảnh seal khi đóng xong', tone: 'done', line: 'next' },
      { key: 'drop', label: 'Hạ cảng', place: 'Cat Lai Giang Nam', time: '14:05', kind: 'dự kiến', code: 'ReturnCode CLGN-261023-077', note: 'Hạ trước cut-off 23/10 23:59', tone: 'next' },
    ],
    chips: [
      { icon: 'truck', text: '50E13970' },
      { icon: 'mooc', text: '50RM07187' },
      { icon: 'cont', text: '40HC · TGHU8123457' },
      { icon: 'km', text: '73,8 / 92 km' },
      { icon: 'driver', text: 'HAI•••' },
    ],
    cutoff: { tone: 'ok', tag: 'Cut-off CY', ok: 'Kịp', text: 'Hạ cont trước 24/Oct/2026 12:00' },
    score: { value: 78, weekAgo: 76 },
    metrics: [
      { label: 'Km thực / kế hoạch', value: '73,8', unit: '/ 92 km', pct: 80, tone: 'blue' },
      { label: 'Giờ chạy', value: '3 g 26′', unit: 'TB tuyến 3 g 40′', pct: 94, tone: 'blue' },
      { label: 'Lấy rỗng so hẹn', value: '+28′', unit: 'hẹn 05:30', pct: 47, tone: 'amber', hot: 'warn' },
      { label: 'Chờ tại kho', value: '4 g 28′', unit: 'chuẩn ≤ 4 g', pct: 89, tone: 'amber', mark: 80, hot: 'warn' },
      { label: 'Nhiên liệu ước tính', value: '27', unit: '/ 31,2 lít · chuẩn DC', pct: 87, tone: 'blue' },
      { label: 'Km rỗng', value: '25%', unit: 'chuẩn ≤ 35%', pct: 50, tone: 'green', mark: 71, hot: 'ok' },
    ],
    flags: ['Ảnh 3/4 pha', 'Chứng từ 4/5', 'Vượt tốc độ 2 lần · QL51', 'Nổ máy đứng yên 4 g 28′'],
    legs: [
      { n: 'L1', kind: 'Chạy rỗng', route: 'Bãi xe COV → ICD PHUOC LONG 3', time: '05:02–05:58', km: '18,2', source: 'Tài xế' },
      { n: 'L2', kind: 'Có hàng', route: 'ICD PHUOC LONG 3 → Kho SAVITA', time: '06:20–08:12', km: '24,6', source: 'GPS tự ghi' },
      { n: 'L3', kind: 'Neo xe chờ kho', route: 'Kho SAVITA', time: '08:12–12:40', km: '0', source: 'GPS đề xuất', pending: true },
      { n: 'L4', kind: 'Có hàng', route: 'Kho SAVITA → Cat Lai Giang Nam', time: '12:40–', km: '31,0', source: 'GPS đề xuất', pending: true },
    ],
    legsPendingMsg: 'L3 neo xe 4 giờ 28 phút tại kho (vượt miễn phí 2 giờ) · không phát hiện mooc đứt hay xe chồng giờ',
    photos: [
      { key: 'PickupEmpty', label: 'Lấy rỗng', n: 3 },
      { key: 'Documents', label: 'Chứng từ', n: 1 },
      { key: 'LeaveWarehouse', label: 'Rời kho', n: 2 },
      { key: 'DropPort', label: 'Hạ cảng', n: 0 },
    ],
    notes: [
      { text: 'Kho SAVITA yêu cầu xe vào cổng phụ, gọi chị Thảo phòng XNK trước 30′', kind: 'Kho', by: 'ThuyNTT', at: '22/10 16:40', pinned: true },
      { text: 'YML xác nhận hạ Cat Lai Giang Nam, không cần xin hạ sớm', kind: 'Hãng', by: 'PhongNT', at: '22/10 17:05' },
      { text: '@DAVID khách xin thêm 1 cont chuyến chiều, chờ booking', kind: 'Nội bộ', by: 'ThuyNTT', at: '23/10 06:10' },
    ],
    docs: { have: 4, total: 5 },
    activity: [
      { tag: 'VETC', text: 'Ghép giao dịch Trạm An Phú (CORR01) vào lệnh', who: 'hệ thống', ini: 'HT', at: '13:18', cat: 'system', tone: 'teal' },
      { tag: 'Chặng', text: 'GPS đề xuất L4 Có hàng · chờ xác nhận', who: 'hệ thống', ini: 'HT', at: '12:40', cat: 'gps', tone: 'teal' },
      { tag: 'Ảnh', text: 'Rời kho · ảnh LeaveWarehouse ×2', who: 'HAI•••', ini: 'HA', at: '12:40', cat: 'driver', tone: 'teal' },
      { tag: 'Chat', text: 'Kho báo đóng hàng xong, seal YML4428119', who: 'ThuyNTT', at: '12:35', cat: 'chat', tone: 'teal' },
      { tag: 'Bước', text: 'Đến kho · GPS tự ghi (ArrivalAutoSet)', who: 'hệ thống', ini: 'HT', at: '08:12', cat: 'gps', tone: 'teal' },
      { tag: 'Tệp', text: 'Gửi 4 chứng từ cho tài xế qua app', who: 'PhongNT', at: '06:31', cat: 'dispatch', tone: 'mute' },
    ],
    activityTotal: 13,
    activityCounts: { all: 13, driver: 3, dispatch: 4, system: 1, gps: 3, chat: 2 },
    todos: [
      { text: 'Xác nhận 2 chặng GPS đề xuất', who: 'THANHTTK', ini: 'TH', due: 'trước Finish', dueTone: 'warn', action: 'Xác nhận' },
      { text: 'Thiếu ảnh pha Hạ cảng (DropPort)', who: 'HAI•••', ini: 'HA', due: 'bắt buộc trước Finish', dueTone: 'err', action: 'Nhắc chụp' },
      { text: 'Chờ EIR hạ hàng', who: 'HAI•••', ini: 'HA', due: 'hạn 24/Oct/2026 12:00', dueTone: 'warn', action: 'Nhắc tài xế' },
      { text: 'Xe trễ lấy rỗng +28′ · ghi lý do', who: 'THANHTTK', ini: 'TH', due: 'hôm nay', dueTone: 'warn', action: 'Ghi lý do' },
    ],
    todosTotal: 6,
    info: [
      { k: 'Job', v: 'SE260637420', link: true, copy: true },
      { k: 'Khách', v: 'SAVITA' },
      { k: 'Container', v: 'TGHU8123457 · 40HC khô', edit: true, copy: true },
      { k: 'Seal', v: 'YML4428119', copy: true },
      { k: 'Booking', v: 'YMJAM490371125', copy: true },
      { k: 'Hãng · tàu', v: 'YML · YM CERTAINTY / 089N' },
      { k: 'Tuyến tàu', v: 'VNSGN → USLAX' },
      { k: 'Kho', v: 'Kho SAVITA · Bình Dương' },
      { k: 'Nhà xe', v: 'HanaLog (xe nhà)' },
    ],
    restrictions: [
      { text: 'Mở 07:00–16:00', tone: 'mute' },
      { text: 'Vào cổng phụ', tone: 'warn' },
      { text: 'Gọi XNK trước 30′', tone: 'mute' },
      { text: 'Geofence 500 m', tone: 'mute' },
    ],
    pics: [
      { who: 'THANHTTK', ini: 'TH', role: 'Điều độ · được giao', tone: 'violet' },
      { who: 'HAI•••', ini: 'HA', role: 'Tài xế · 50E13970 · được giao', tone: 'violet' },
      { who: 'DAVID', ini: 'DA', role: 'Sale · theo khách', tone: 'blue' },
      { who: 'NGOCNTB', ini: 'NG', role: 'CS · theo khách', tone: 'mute' },
      { who: 'Chưa giao', ini: '?', role: 'Sale Asst · theo khách', none: true, tone: 'mute' },
      { who: 'LIENNTK', ini: 'LI', role: 'Kế toán · theo khách', tone: 'mute' },
    ],
    driver: { ini: 'HA', name: 'HAI•••', status: '50E13970 · đang chạy L4 · QL51' },
  },
};

/** Số chặng GPS đề xuất đang chờ xác nhận. */
export const pendingLegs = (d: Pick<TripDetail, 'legs'>): number => d.legs.filter((l) => l.pending).length;

/** Số pha chưa có ảnh (bắt buộc trước Finish). */
export const phasesWithPhoto = (d: Pick<TripDetail, 'photos'>): number => d.photos.filter((p) => p.n > 0).length;

/** Lọc dòng hoạt động theo nhóm; `all` giữ nguyên. */
export const filterActivity = (rows: readonly Activity[], cat: 'all' | ActCat): Activity[] => (cat === 'all' ? [...rows] : rows.filter((r) => r.cat === cat));

/** Xác nhận một chặng GPS đề xuất (giả lập, trả bản mới; không đổi bản gốc). */
export const confirmLeg = (legs: readonly Leg[], n: string): Leg[] => legs.map((l) => (l.n === n ? { ...l, pending: false } : l));

/** Xác nhận mọi chặng đang chờ. */
export const confirmAllLegs = (legs: readonly Leg[]): Leg[] => legs.map((l) => (l.pending ? { ...l, pending: false } : l));
